(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cottona-envio-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setupBlock(block) {
    /* CONTADOR */
    var qty   = block.querySelector('.ctn-counter-val');
    var minus = block.querySelector('[data-action="minus"]');
    var plus  = block.querySelector('[data-action="plus"]');
    if (qty && minus && plus) {
      plus.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1;
        if (v < 50) qty.value = v + 1;
      });
      minus.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1;
        if (v > 1) qty.value = v - 1;
      });
    }

    /* CAMPOS DINÁMICOS */
    var sel         = block.querySelector('.ctn-select');
    var dirField    = block.querySelector('[id$="-dir-field"]');
    var dirInput    = block.querySelector('[id$="-dir"]');
    var agField     = block.querySelector('[id$="-agencia-field"]');
    var agInput     = block.querySelector('[id$="-agencia"]');
    var recojoField = block.querySelector('[id$="-recojo-field"]');

    if (!sel) return;

    function updateFields() {
      /* oculta todos */
      [dirField, agField, recojoField].forEach(function(f){ if(f) f.style.display = 'none'; });
      if (dirInput)  { dirInput.removeAttribute('required'); dirInput.value = ''; }
      if (agInput)   { agInput.removeAttribute('required');  agInput.value  = ''; }

      var v = sel.value;
      if (v === 'Motorizado Lima') {
        if (dirField) dirField.style.display = 'flex';
        if (dirInput) dirInput.setAttribute('required', 'required');
      } else if (v === 'Shalom - Provincias') {
        if (agField) agField.style.display = 'flex';
        if (agInput) agInput.setAttribute('required', 'required');
      } else if (v === 'Recojo en tienda') {
        if (recojoField) recojoField.style.display = 'flex';
      }
    }

    sel.addEventListener('change', updateFields);
    updateFields(); /* estado inicial */
  }

  function init() {
    document.querySelectorAll('.ctn-envio-block').forEach(setupBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["libro-reclamaciones"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init() {
    document.querySelectorAll('.lr-seccion').forEach(function(seccion) {
      var radiosTipo = seccion.querySelectorAll('input[name="lr-tipo-solicitud"]');
      var hiddenTipo = seccion.querySelector('#lr-tipo-solicitud-input');
      radiosTipo.forEach(function(radio) {
        radio.addEventListener('change', function() {
          if (hiddenTipo) hiddenTipo.value = radio.value;
        });
      });

      var menorCheck = seccion.querySelector('#lr-menor-check');
      var menorDatos = seccion.querySelector('#lr-menor-datos');
      if (menorCheck && menorDatos) {
        menorCheck.addEventListener('change', function() {
          menorDatos.classList.toggle('lr-menor-datos--visible', menorCheck.checked);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["packs-carrusel"] && !Shopify.designMode) return;
  try {
    
(function() {
  function iniciarCarrusel(seccionId) {
    var seccion = document.getElementById('packs-seccion-' + seccionId);
    if (!seccion) return;

    var carrusel = document.getElementById('packs-carrusel-' + seccionId);
    if (!carrusel) return;
    var tarjetas = Array.from(carrusel.querySelectorAll('.packs-tarjeta'));
    var btnPrev = document.getElementById('packs-prev-' + seccionId);
    var btnNext = document.getElementById('packs-next-' + seccionId);

    if (!tarjetas.length) return;

    var totalReal = tarjetas.length / 5;
    var indiceActivo = totalReal * 2;
    var navegandoCarrusel = false;

    function calcularOffset(idx) {
      var anchoWrapper = carrusel.parentElement.clientWidth;
      var anchoTarjeta = tarjetas[0].offsetWidth;
      var gap = window.innerWidth >= 749 ? 18 : 14;
      var desplazamiento = idx * (anchoTarjeta + gap);
      var centro = (anchoWrapper / 2) - (anchoTarjeta / 2);
      return centro - desplazamiento;
    }

    function actualizarCarrusel(animado) {
      tarjetas.forEach(function(t, i) {
        t.classList.toggle('packs-tarjeta--activa', i === indiceActivo);
      });
      var offset = calcularOffset(indiceActivo);
      carrusel.style.transition = animado ? 'transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      carrusel.style.transform = 'translateX(' + offset + 'px)';
    }

    carrusel.addEventListener('transitionend', function(e) {
      if (e.target !== carrusel) return;
      var setIndex = Math.floor(indiceActivo / totalReal);
      if (setIndex >= 4 || setIndex <= 0) {
        indiceActivo = (totalReal * 2) + (indiceActivo % totalReal);
        actualizarCarrusel(false);
      }
    });

    if (btnPrev) {
      btnPrev.addEventListener('click', function() {
        if (navegandoCarrusel) return;
        indiceActivo--;
        actualizarCarrusel(true);
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function() {
        if (navegandoCarrusel) return;
        indiceActivo++;
        actualizarCarrusel(true);
      });
    }

    var startX = 0, startY = 0, swipeDir = null;

    carrusel.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swipeDir = null;
      navegandoCarrusel = false;
    }, { passive: true });

    carrusel.addEventListener('touchmove', function(e) {
      if (swipeDir !== null) return;
      var diffX = Math.abs(e.touches[0].clientX - startX);
      var diffY = Math.abs(e.touches[0].clientY - startY);
      if (diffX > 6 || diffY > 6) {
        swipeDir = diffX > diffY ? 'horizontal' : 'vertical';
      }
    }, { passive: true });

    carrusel.addEventListener('touchend', function(e) {
      if (swipeDir !== 'horizontal') { navegandoCarrusel = false; return; }
      var diffX = startX - e.changedTouches[0].clientX;
      if (Math.abs(diffX) > 40) {
        navegandoCarrusel = true;
        if (diffX > 0) { indiceActivo++; } else { indiceActivo--; }
        actualizarCarrusel(true);
        setTimeout(function() { navegandoCarrusel = false; }, 500);
      } else {
        navegandoCarrusel = false;
      }
      swipeDir = null;
    }, { passive: true });

    var anchoAnterior = window.innerWidth;
    var resizeTimer;
    window.addEventListener('resize', function() {
      if (window.innerWidth === anchoAnterior) return;
      anchoAnterior = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() { actualizarCarrusel(false); }, 150);
    });

    setTimeout(function() { actualizarCarrusel(false); }, 50);
  }

  function init() {
    document.querySelectorAll('[id^="packs-seccion-"]').forEach(function(el) {
      var id = el.id.replace('packs-seccion-', '');
      iniciarCarrusel(id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-videos-testimonios"] && !Shopify.designMode) return;
  try {
    

(function() {

  function iniciarCarrusel(seccionId) {

    var seccion = document.getElementById(
      'testi-seccion-' + seccionId
    );

    if (!seccion) return;


    var carrusel = document.getElementById(
      'testi-carrusel-' + seccionId
    );

    if (!carrusel) return;


    var tarjetas = Array.from(
      carrusel.querySelectorAll('.testi-tarjeta')
    );


    var btnPrev = document.getElementById(
      'testi-prev-' + seccionId
    );

    var btnNext = document.getElementById(
      'testi-next-' + seccionId
    );


    if (!tarjetas.length) return;


    /* =====================================================
       CONFIGURACIÓN
    ===================================================== */

    var totalReal = tarjetas.length / 5;

    var indiceActivo = totalReal * 2;

    var videosCargados = {};

    var navegandoCarrusel = false;

    var RADIO_PRECARGA = 2;


    /* =====================================================
       ESTADO GLOBAL DE AUDIO
       Se conserva al cambiar de video
    ===================================================== */

    var storageKey =
      'testi-audio-muted-' + seccionId;

    var audioMuteado = true;


    try {

      var estadoGuardado =
        localStorage.getItem(storageKey);

      if (estadoGuardado === 'false') {
        audioMuteado = false;
      } else {
        audioMuteado = true;
      }

    } catch (error) {

      audioMuteado = true;

    }


    function guardarEstadoAudio() {

      try {

        localStorage.setItem(
          storageKey,
          audioMuteado ? 'true' : 'false'
        );

      } catch (error) {}

    }


    /* =====================================================
       SKELETON
    ===================================================== */

    tarjetas.forEach(function(tarjeta) {

      var wrapper =
        tarjeta.querySelector('.testi-video-wrapper');

      if (!wrapper) return;

      var skeleton =
        document.createElement('div');

      skeleton.className =
        'testi-skeleton';

      wrapper.appendChild(skeleton);

    });


    /* =====================================================
       CARGAR VIDEO
    ===================================================== */

    function cargarVideo(tarjeta) {

      var idx =
        tarjetas.indexOf(tarjeta);

      if (videosCargados[idx]) return;


      var src =
        tarjeta.dataset.videoSrc;

      if (!src) return;


      var video =
        tarjeta.querySelector('.testi-video');

      if (!video) return;


      videosCargados[idx] = true;


      video.addEventListener(
        'canplay',
        function onCanPlay() {

          video.removeEventListener(
            'canplay',
            onCanPlay
          );


          var skeleton =
            tarjeta.querySelector(
              '.testi-skeleton'
            );


          if (skeleton) {
            skeleton.classList.add(
              'testi-skeleton--oculto'
            );
          }

        },
        { once: true }
      );


      video.src = src;

      video.load();

    }


    /* =====================================================
       PRECARGAR VECINOS
    ===================================================== */

    function cargarVecinos(idx) {

      for (
        var offset = -RADIO_PRECARGA;
        offset <= RADIO_PRECARGA;
        offset++
      ) {

        if (tarjetas[idx + offset]) {

          cargarVideo(
            tarjetas[idx + offset]
          );

        }

      }

    }


    /* =====================================================
       OBSERVER
    ===================================================== */

    var seccionObserver =
      new IntersectionObserver(
        function(entries) {

          entries.forEach(
            function(entry) {

              if (entry.isIntersecting) {

                cargarVecinos(
                  indiceActivo
                );

                seccionObserver.disconnect();

              }

            }
          );

        },
        {
          threshold: 0.1
        }
      );


    seccionObserver.observe(seccion);


    /* =====================================================
       CALCULAR POSICIÓN
    ===================================================== */

    function calcularOffset(idx) {

      var anchoWrapper =
        carrusel.parentElement.clientWidth;

      var anchoTarjeta =
        tarjetas[0].offsetWidth;

      var gap =
        window.innerWidth >= 749
          ? 16
          : 12;


      var desplazamientoElemento =
        idx * (anchoTarjeta + gap);


      var centroPantalla =
        (anchoWrapper / 2) -
        (anchoTarjeta / 2);


      return (
        centroPantalla -
        desplazamientoElemento
      );

    }


    /* =====================================================
       ACTUALIZAR BOTÓN DE MUTE
    ===================================================== */

    function resetMuteBtn(
      tarjeta,
      video
    ) {

      var btnMute =
        tarjeta.querySelector(
          '.testi-btn-mute'
        );


      if (!btnMute) return;


      if (video.muted) {

        btnMute.classList.add(
          'testi-is-muted'
        );

        btnMute.setAttribute(
          'aria-label',
          'Activar sonido'
        );

      } else {

        btnMute.classList.remove(
          'testi-is-muted'
        );

        btnMute.setAttribute(
          'aria-label',
          'Silenciar'
        );

      }

    }


    /* =====================================================
       REPRODUCIR VIDEO ACTIVO
    ===================================================== */

    function reproducirActivo() {

      tarjetas.forEach(
        function(t, i) {

          var video =
            t.querySelector(
              '.testi-video'
            );


          if (!video) return;


          if (i === indiceActivo) {

            if (!video.src) return;


            /*
             * IMPORTANTE:
             * Ya NO forzamos muted=true.
             * Se utiliza el estado guardado.
             */

            video.muted =
              audioMuteado;


            resetMuteBtn(
              t,
              video
            );


            var promise =
              video.play();


            if (
              promise !== undefined
            ) {

              promise.then(
                function() {

                  t.classList.add(
                    'testi-tarjeta--reproduciendo'
                  );

                  resetMuteBtn(
                    t,
                    video
                  );

                }
              ).catch(
                function() {}
              );

            }

          } else {

            /*
             * Pausamos los videos
             * que no están activos.
             */

            video.pause();

            video.currentTime = 0;

            /*
             * NO modificamos video.muted.
             * Así no destruimos el estado
             * de audio elegido por el usuario.
             */

            t.classList.remove(
              'testi-tarjeta--reproduciendo'
            );

            resetMuteBtn(
              t,
              video
            );

          }

        }
      );

    }


    var ultimoIndiceReproducido =
      null;


    /* =====================================================
       ACTUALIZAR CARRUSEL
    ===================================================== */

    function actualizarCarrusel(
      animado
    ) {

      tarjetas.forEach(
        function(t, i) {

          t.classList.toggle(
            'testi-tarjeta--activa',
            i === indiceActivo
          );

        }
      );


      var offset =
        calcularOffset(
          indiceActivo
        );


      carrusel.style.transition =
        animado
          ? 'transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)'
          : 'none';


      carrusel.style.transform =
        'translateX(' +
        offset +
        'px)';


      cargarVecinos(
        indiceActivo
      );


      if (
        ultimoIndiceReproducido !==
        indiceActivo
      ) {

        ultimoIndiceReproducido =
          indiceActivo;

        reproducirActivo();

      }

    }


    /* =====================================================
       CARRUSEL INFINITO
    ===================================================== */

    carrusel.addEventListener(
      'transitionend',
      function(e) {

        if (e.target !== carrusel)
          return;


        var setIndex =
          Math.floor(
            indiceActivo /
            totalReal
          );


        if (
          setIndex >= 4 ||
          setIndex <= 0
        ) {

          var oldVideo =
            tarjetas[indiceActivo]
              ? tarjetas[indiceActivo]
                  .querySelector(
                    '.testi-video'
                  )
              : null;


          var currentTime =
            oldVideo
              ? oldVideo.currentTime
              : 0;


          var targetIndex =
            (totalReal * 2) +
            (indiceActivo % totalReal);


          indiceActivo =
            targetIndex;


          actualizarCarrusel(
            false
          );


          var newVideo =
            tarjetas[indiceActivo]
              ? tarjetas[indiceActivo]
                  .querySelector(
                    '.testi-video'
                  )
              : null;


          if (newVideo) {

            newVideo.currentTime =
              currentTime;

          }

        }

      }
    );


    /* =====================================================
       EVENTOS DE TARJETAS
    ===================================================== */

    tarjetas.forEach(
      function(tarjeta, i) {

        var btnPlay =
          tarjeta.querySelector(
            '.testi-btn-play'
          );


        var btnMute =
          tarjeta.querySelector(
            '.testi-btn-mute'
          );


        var video =
          tarjeta.querySelector(
            '.testi-video'
          );


        /* ===============================================
           CLICK TARJETA
        =============================================== */

        tarjeta.addEventListener(
          'click',
          function() {

            if (navegandoCarrusel)
              return;


            if (i !== indiceActivo) {

              indiceActivo = i;

              actualizarCarrusel(
                true
              );

            } else {

              if (!video) return;


              if (video.paused) {

                video.muted =
                  audioMuteado;


                video.play()
                  .then(
                    function() {

                      tarjeta.classList.add(
                        'testi-tarjeta--reproduciendo'
                      );

                      resetMuteBtn(
                        tarjeta,
                        video
                      );

                    }
                  )
                  .catch(
                    function() {}
                  );

              } else {

                video.pause();

                tarjeta.classList.remove(
                  'testi-tarjeta--reproduciendo'
                );

              }

            }

          }
        );


        /* ===============================================
           BOTÓN PLAY
        =============================================== */

        if (
          btnPlay &&
          video
        ) {

          btnPlay.addEventListener(
            'click',
            function(e) {

              e.stopPropagation();


              if (navegandoCarrusel)
                return;


              if (
                i !==
                indiceActivo
              ) {

                indiceActivo =
                  i;

                actualizarCarrusel(
                  true
                );

              } else {

                video.muted =
                  audioMuteado;


                video.play()
                  .then(
                    function() {

                      tarjeta.classList.add(
                        'testi-tarjeta--reproduciendo'
                      );

                      resetMuteBtn(
                        tarjeta,
                        video
                      );

                    }
                  )
                  .catch(
                    function() {}
                  );

              }

            }
          );

        }


        /* ===============================================
           BOTÓN MUTE
        =============================================== */

        if (
          btnMute &&
          video
        ) {

          btnMute.addEventListener(
            'click',
            function(e) {

              e.stopPropagation();


              /*
               * Invertimos el estado global.
               */

              audioMuteado =
                !video.muted;


              /*
               * Aplicamos el nuevo estado
               * al video actual.
               */

              video.muted =
                audioMuteado;


              /*
               * Guardamos para que sobreviva
               * al cambiar de video.
               */

              guardarEstadoAudio();


              resetMuteBtn(
                tarjeta,
                video
              );

            }
          );

        }

      }
    );


    /* =====================================================
       FLECHA ANTERIOR
    ===================================================== */

    if (btnPrev) {

      btnPrev.addEventListener(
        'click',
        function() {

          if (navegandoCarrusel)
            return;


          indiceActivo--;

          actualizarCarrusel(
            true
          );

        }
      );

    }


    /* =====================================================
       FLECHA SIGUIENTE
    ===================================================== */

    if (btnNext) {

      btnNext.addEventListener(
        'click',
        function() {

          if (navegandoCarrusel)
            return;


          indiceActivo++;

          actualizarCarrusel(
            true
          );

        }
      );

    }


    /* =====================================================
       SWIPE
    ===================================================== */

    var startX = 0;

    var startY = 0;

    var swipeDir = null;


    carrusel.addEventListener(
      'touchstart',
      function(e) {

        startX =
          e.touches[0].clientX;

        startY =
          e.touches[0].clientY;

        swipeDir = null;

        navegandoCarrusel = false;

      },
      {
        passive: true
      }
    );


    carrusel.addEventListener(
      'touchmove',
      function(e) {

        if (
          swipeDir !== null
        )
          return;


        var diffX =
          Math.abs(
            e.touches[0].clientX -
            startX
          );


        var diffY =
          Math.abs(
            e.touches[0].clientY -
            startY
          );


        if (
          diffX > 6 ||
          diffY > 6
        ) {

          swipeDir =
            diffX > diffY
              ? 'horizontal'
              : 'vertical';

        }

      },
      {
        passive: true
      }
    );


    carrusel.addEventListener(
      'touchend',
      function(e) {

        if (
          swipeDir !==
          'horizontal'
        ) {

          navegandoCarrusel =
            false;

          return;

        }


        var diffX =
          startX -
          e.changedTouches[0].clientX;


        if (
          Math.abs(diffX) > 40
        ) {

          navegandoCarrusel =
            true;


          if (diffX > 0) {

            indiceActivo++;

          } else {

            indiceActivo--;

          }


          actualizarCarrusel(
            true
          );


          setTimeout(
            function() {

              navegandoCarrusel =
                false;

            },
            500
          );

        } else {

          navegandoCarrusel =
            false;

        }


        swipeDir = null;

      },
      {
        passive: true
      }
    );


    /* =====================================================
       VISIBILITY CHANGE
    ===================================================== */

    document.addEventListener(
      'visibilitychange',
      function() {

        var tarjetaActiva =
          tarjetas[indiceActivo];


        var videoActivo =
          tarjetaActiva
            ? tarjetaActiva.querySelector(
                '.testi-video'
              )
            : null;


        if (!videoActivo)
          return;


        if (document.hidden) {

          videoActivo.pause();

        } else {

          if (!videoActivo.src)
            return;


          /*
           * Recuperar estado de audio.
           */

          videoActivo.muted =
            audioMuteado;


          resetMuteBtn(
            tarjetaActiva,
            videoActivo
          );


          videoActivo.play()
            .then(
              function() {

                tarjetaActiva.classList.add(
                  'testi-tarjeta--reproduciendo'
                );

              }
            )
            .catch(
              function() {}
            );

        }

      }
    );


    /* =====================================================
       RESIZE
    ===================================================== */

    var anchoAnterior =
      window.innerWidth;

    var resizeTimer;


    window.addEventListener(
      'resize',
      function() {

        if (
          window.innerWidth ===
          anchoAnterior
        )
          return;


        anchoAnterior =
          window.innerWidth;


        clearTimeout(
          resizeTimer
        );


        resizeTimer =
          setTimeout(
            function() {

              actualizarCarrusel(
                false
              );

            },
            150
          );

      }
    );


    /* =====================================================
       INICIALIZACIÓN
    ===================================================== */

    setTimeout(
      function() {

        actualizarCarrusel(
          false
        );

      },
      50
    );

  }


  /* =======================================================
     INIT
  ======================================================= */

  function init() {

    document
      .querySelectorAll(
        '[id^="testi-seccion-"]'
      )
      .forEach(
        function(el) {

          var id =
            el.id.replace(
              'testi-seccion-',
              ''
            );


          iniciarCarrusel(id);

        }
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();


  } catch(e) { console.error(e); }
})();
})();
